exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header_2GdVG {\n    width: 100%;\n}\n\n.radioButtonLabel_FO131 {\n    margin-left: 2px;\n}\n", ""]);

// exports
exports.locals = {
	"header": "header_2GdVG",
	"radioButtonLabel": "radioButtonLabel_FO131"
};